module.exports = __webpack_public_path__ + "static/media/star.454c4776.png";